import React from "react";

const Info = () => {
  return <div className="info">INFO</div>;
};

export default Info;
